export const checkIfNavFixed = (navObject:any) => {
    // We have 3 settings but do not diffenciate fixed on different platforms at the moment
    return navObject.settings.isFixed.desktop && navObject.settings.isFixed.tablets && navObject.settings.isFixed.mobiles;
};